import { noop } from "lodash";
import stripeLogo from "../../static/images/icons/stripe.svg";
import { CreateStripeConnection } from "../stripe/CreateStripeConnection";
import styles from "./ConnectOverlay.module.scss";

export const ConnectOverlay = () => (
    <div className={styles.connectOverlay}>
        <div className={styles.connectOverlayContent}>
            <img src={stripeLogo} alt="Stripe" />
            <span className={styles.connectOverlayText}>
                Connect your Stripe account to view Invoices.
            </span>
            <span className={styles.connectOverlaySubtext}>
                Kick supports the ability to view and manage your Stripe
                Invoices.
                <br />
                Additional providers will be available soon.
            </span>
            <CreateStripeConnection
                onCreated={noop}
                btnVariant="default"
                btnSize="default"
                toastMessage="Syncing Stripe Invoices... Check back in a few minutes."
            >
                Connect Stripe
            </CreateStripeConnection>
        </div>
    </div>
);
